export const NIGHT_EYE_API_URL ="https://nighteyes.in/NightEyeAPI/api/v1/"
export const NIGHT_EYE_IMG_URL ="https://nighteyes.in/NightEyeAPI/"

export const Scan_URL ="https://nighteyes.in/"



// eslint-disable-next-line react-hooks/exhaustive-deps